module.exports = __webpack_public_path__ + "img/cend2_zh.75c0ef6.png";